<script setup>
import { computed } from 'vue'
import { BuildingStorefrontIcon, MapPinIcon } from '@heroicons/vue/24/outline'
import { useI18n } from '../i18n.js'

const props = defineProps({
  context: { type: Object, default: null },
  disabled: { type: Boolean, default: false },
  compact: { type: Boolean, default: false },
  pts2: { type: Boolean, default: false },
  showStableCode: { type: Boolean, default: true },
})
const emit = defineEmits(['select'])
const { t } = useI18n()
const stations = computed(() => props.context?.stations ?? [])

function select(event) {
  const stationId = Number(event.target.value)
  if (stationId) emit('select', stationId)
}
</script>

<template>
  <label class="platform-context-selector" :class="{ compact }">
    <component :is="pts2 ? BuildingStorefrontIcon : MapPinIcon" aria-hidden="true" />
    <span v-if="!compact">{{ t('physicalStation') }}</span>
    <select :value="context?.activeStationId ?? ''" :disabled="disabled || !stations.length"
      :aria-label="t('physicalStation')" @change="select">
      <option value="" disabled>{{ stations.length ? t('choosePhysicalStation') : t('noAccessibleStations') }}</option>
      <option v-for="station in stations" :key="station.id" :value="station.id" :disabled="station.status !== 'ACTIVE'">
        {{ station.displayName }}<template v-if="showStableCode"> · {{ station.stableCode }}</template>
      </option>
    </select>
  </label>
</template>
